import PropTypes from 'prop-types';

import { SFEntityID } from 'utils/types';

export const questionFilterPanelType = {
  question: PropTypes.shape({
    id: SFEntityID.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }),
  enabled: PropTypes.bool.isRequired,

  onSubmit: PropTypes.func,

  addSelection: PropTypes.func.isRequired,
  removeSelection: PropTypes.func.isRequired,
};

export default questionFilterPanelType;
